import { useContext } from "react";
import { langContext, type Language } from "../api/Lang";

const el = {
    defaultMessage:
        "Η πλατφόρμα είναι προσωρινά μη διαθέσιμη για συντήρηση. Θα επιστρέψουμε σύντομα.",
    loading: "Παρακαλώ, περιμένετε...",
};

const en: typeof el = {
    defaultMessage:
        "The site is temporarily unavailable for maintenance. We will be back shortly.",
    loading: "Please, wait...",
};

const maintenanceLangs = { el, en };

export type MaintenanceStrings = typeof el;

export function getMaintenanceStrings(lang: Language): MaintenanceStrings {
    return maintenanceLangs[lang];
}

export function useMaintenanceStrings(): MaintenanceStrings {
    const [lang] = useContext(langContext);
    return getMaintenanceStrings(lang);
}
